import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/apply')({
  component: ApplyRoute
});

function ApplyRoute() {
  return <div>Hello "/apply"!</div>;
}
